import axios from 'axios';
import {delToken} from "@/utils/utils";
import {toLogin} from "@/router/utils";
import {getLang} from "@/lang/utils";

export const Axios = axios.create({
  timeout: 1000 * 120
});

// POST传参序列化(添加请求拦截器)
// 在发送请求之前做某件事
Axios.interceptors.request.use(
  config => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
    config.headers['Fu-Language'] = getLang()
    if (config.url.indexOf('?') !== -1) {
      config.url = config.url + '&_=' + new Date().getTime();
    } else {
      config.url = config.url + '?_=' + new Date().getTime();
    }
    return config;
  },
  error => {
    alert('错误的传参', 'fail');
    return Promise.reject(error);
  }
);

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    // 对响应数据做些事
    if (res.status !== 200) {
      alert('响应失败');
      return Promise.reject(res);
    }
    if (res.data.error_code === -3 || res.data.error_code === -4) {
      delToken()
      // window.location.href = window.location.protocol + '//' + window.location.host + '/login';
      toLogin()
    }
    return res;
  },
  error => {
    console.log(error);
    // 返回 response 里的错误信息
    return Promise.reject(error);
  }
);

Axios.all = axios.all;

export default Axios;
